import { useGameStore } from '../../store/GameStoreContext.ts';
import { TradeResponseStatus } from '@colonist/game-states';
import { useMemo } from 'react';
export const useIsPlayerTakingAction = (playerColor)=>{
    const isTakingAction = useGameStore((state)=>{
        var _state_gameState_playerStates_playerColor;
        var _state_gameState_playerStates_playerColor_isTakingAction;
        return (_state_gameState_playerStates_playerColor_isTakingAction = (_state_gameState_playerStates_playerColor = state.gameState.playerStates[playerColor]) === null || _state_gameState_playerStates_playerColor === void 0 ? void 0 : _state_gameState_playerStates_playerColor.isTakingAction) !== null && _state_gameState_playerStates_playerColor_isTakingAction !== void 0 ? _state_gameState_playerStates_playerColor_isTakingAction : false;
    });
    const tradeState = useGameStore((state)=>state.gameState.tradeState);
    return useMemo(()=>{
        if (isTakingAction) return true;
        for (const activeTradeOffer of Object.values(tradeState.activeOffers)){
            if (activeTradeOffer === undefined) continue;
            if (activeTradeOffer.creator === playerColor) return true;
            if (activeTradeOffer.playersCreatingCounterOffer[playerColor] === true) return true;
            if (activeTradeOffer.playerResponses[playerColor] === TradeResponseStatus.PendingResponse) return true;
        }
        return false;
    }, [
        isTakingAction,
        tradeState
    ]);
};
